import './Footer.css';

import social1 from '../assets/alliatus/social-1.svg';
import social2 from '../assets/alliatus/social-2.svg';
import social3 from '../assets/alliatus/social-3.svg';
import social4 from '../assets/alliatus/social-4.svg';

const FOOTER_LINKS = ['Contact', 'Privacy Policy', 'Terms of Service'];
const CURRENT_YEAR = new Date().getFullYear();

function Footer() {
    return (
        <footer className="al-footer" id="footer">
            <div className="al-shell">
                <div className="al-footer-panel">
                    <div className="al-footer-main">
                        <p className="al-logo al-logo--light">Numus</p>
                        <div className="al-footer-links">
                            {FOOTER_LINKS.map((label) => (
                                <a key={label} href="/">{label}</a>
                            ))}
                        </div>
                        <div className="al-social">
                            <a
                                className="al-social-icon"
                                href="https://www.instagram.com"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Instagram"
                                style={{ WebkitMaskImage: `url(${social1})`, maskImage: `url(${social1})` }}
                            />
                            <a
                                className="al-social-icon"
                                href="https://x.com"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="X"
                                style={{ WebkitMaskImage: `url(${social2})`, maskImage: `url(${social2})` }}
                            />
                            <a
                                className="al-social-icon"
                                href="https://www.facebook.com"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Facebook"
                                style={{ WebkitMaskImage: `url(${social3})`, maskImage: `url(${social3})` }}
                            />
                            <a
                                className="al-social-icon"
                                href="https://www.linkedin.com"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="LinkedIn"
                                style={{ WebkitMaskImage: `url(${social4})`, maskImage: `url(${social4})` }}
                            />
                        </div>
                        <p className="al-footer-copy">
                            © {CURRENT_YEAR} Actuation GmbH. All rights reserved.
                            <br />
                            Powered by AI, data, and your network.
                        </p>
                    </div>
                    <div className="al-footer-cta">
                        <h2 className="al-h3">
                            Ready to Land <span className="al-em">What’s Next?</span>
                        </h2>
                        <p className="al-body">
                            Stop scrolling endless listings. Let Numus match you with roles that fit —
                            and help you move faster.
                            <br /><br />
                            Your next opportunity is closer than you think.
                        </p>
                        <button className="al-btn al-btn--dark" type="button">Join Numus</button>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
